export default __webpack_public_path__ + "locales/zh-CN/Settings.json?hash=5f027a285535b13ddc96973b2049f97a";